/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import React from 'react';
import YesNoAction from '../../components/YesNoAction';
import { URLS } from '../../util/consts';
import { Box } from '@mui/material';
import TestIds from '../../testIds';

interface NoOrdersProps {
  bodyText: string;
  bodyPropsSx?: React.CSSProperties;
}

export const NoOrders = (props: NoOrdersProps) => {
  function onClickFindStore() {
    window.open(URLS.findStore, '_blank');
  }

  function onClickAllProducts() {
    window.open('/products?tab=0', '_self');
  }

  return (
    <Box data-testid={TestIds.feat.orders.list.noOrders}>
      <YesNoAction
        bodyProps={{ sx: props.bodyPropsSx }}
        body={props.bodyText}
        optionA={{
          label: 'Shop Farmlands products',
          onClick: onClickAllProducts,
        }}
        optionB={{
          label: 'Find a store',
          onClick: onClickFindStore,
        }}
      />
    </Box>
  );
};
